import { map } from 'lodash';
import parse from 'date-fns/parse';
import { setSurgeries } from './actions';
import { currentPatientIdSelector } from '../patient';
import SurgeriesService from './SurgeriesService';

const toSurgeriesRequest = ({ type, date, hospital, notes }) => ({
  date: parse(date),
  description: type,
  hospital: hospital,
  notes: notes,
});

const toRequest = (surgeries, patientId) => ({
  surgeries: map(surgeries, surgery => toSurgeriesRequest(surgery)),
  patientId,
});

export const fetchSurgeriesAsync = () => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(SurgeriesService.getByPatientId(patientId)).then(surgeries =>
    dispatch(setSurgeries(surgeries)),
  );
};

export const saveSurgeriesAsync = surgeries => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(
    SurgeriesService.create(toRequest(surgeries, patientId)),
  ).then(() => dispatch(setSurgeries(surgeries)));
};



// WEBPACK FOOTER //
// ./src/lib/dataLayer/surgeries/thunks.js